export default "__VITE_ASSET__kfsw84AH__"